import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskOverview = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 249,
	height: 160,
	viewBox: "0 0 249 160",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_17365",
				"data-name": "Rectangle 17365",
				width: 249,
				height: 160,
				transform: "translate(1385 779)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39602",
				"data-name": "Path 39602",
				d: "M1261.851,118.53c-6.107.171-10,6.323-10.353,6.9-4.127,6.732.249,11.483-1.729,19.869-2.741,11.622-12.97,10.238-15.917,20.6-3.6,12.673,10.03,20.626,5.488,32.833-2.439,6.556-6.91,5.706-10.68,13.843-3.229,6.969-4.834,18.136.048,23.738,9.958,11.427,46.836-.377,49.855-15.391,1.312-6.527-4.632-9.39-3.62-19.188,1.089-10.551,8.409-11.36,9.58-20.853,1.418-11.5-8.92-13.521-10.168-28.876-.916-11.278,4.263-15.089.5-23.224-2-4.339-6.711-10.253-12.75-10.253q-.129,0-.259,0",
				transform: "translate(-1225.615 -118.526)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16887",
				"data-name": "Rectangle 16887",
				width: 31.463,
				height: 129.548,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-4",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16888",
				"data-name": "Rectangle 16888",
				width: 11.345,
				height: 35.055,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-5",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16889",
				"data-name": "Rectangle 16889",
				width: 24.184,
				height: 38.37,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-6",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16890",
				"data-name": "Rectangle 16890",
				width: 22.845,
				height: 35.462,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-7",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16891",
				"data-name": "Rectangle 16891",
				width: 14.505,
				height: 33.38,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-8",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16895",
				"data-name": "Rectangle 16895",
				width: 181.784,
				height: 186.564,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-9",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16894",
				"data-name": "Rectangle 16894",
				width: 232.606,
				height: 145.845,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-10",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39609",
				"data-name": "Path 39609",
				d: "M252.155,792.351c-5.029.268-9.141-2.6-9.141-6.405V653.132c0-3.8,4.113-6.762,9.141-6.6l215.561,9.57c3.815.122,7.9.224,7.9,3.51v114.85c0,3.287-3.089,6.126-6.9,6.329Z",
				transform: "translate(-243.013 -646.523)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: .016,
			y1: .908,
			x2: .016,
			y2: .908,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#d8dee8"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#a2a7ae"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-11",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39610",
				"data-name": "Path 39610",
				d: "M259.284,653.131V785.945c0,3.8,4.176,6.674,9.282,6.405L488.447,780.79c3.874-.2,7.01-3.043,7.01-6.33V659.61c0-3.287-3.137-6.059-7.01-6.181l-219.882-6.9c-.132,0-.264-.006-.395-.006-4.924,0-8.887,2.906-8.887,6.608",
				transform: "translate(-259.284 -646.523)",
				fill: "#fafafa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-12",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39611",
				"data-name": "Path 39611",
				d: "M315.414,720.863V853.208c0,1.284,1.4,2.254,3.129,2.168L538.425,844.39a2.361,2.361,0,0,0,2.379-2.142v-115.2a2.3,2.3,0,0,0-2.379-2.091l-219.882-6.326-.123,0c-1.67,0-3.006.983-3.006,2.236",
				transform: "translate(-315.414 -718.627)",
				fill: "#edefff"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-13",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16898",
				"data-name": "Rectangle 16898",
				width: 74.555,
				height: 111.521,
				fill: "#fff"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-14",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39615",
				"data-name": "Path 39615",
				d: "M420.182,1478.135v18.047a30.377,30.377,0,0,0,1.067,7.981l.271.995a.848.848,0,0,0,.819.626h34.394a.728.728,0,0,0,.711-.888,49.788,49.788,0,0,1-1.3-8.565v-16.622a1.41,1.41,0,0,0-1.367-1.409l-33.717-1.013h-.026a.849.849,0,0,0-.848.849",
				transform: "translate(-420.182 -1477.286)",
				fill: "#b5bdf5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-15",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39641",
				"data-name": "Path 39641",
				d: "M448.116,994.763l29.886-.2c-2-7.191-4.513-14.748-3.993-22.9l-30.326-.952c.063,11.269.632,21.377,4.433,24.054",
				transform: "translate(-443.683 -970.709)",
				fill: "#7284fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-17",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16932",
				"data-name": "Rectangle 16932",
				width: 48.25,
				height: 54.015,
				fill: "#b8b8d0"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-18",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39642",
				"data-name": "Path 39642",
				d: "M1076.971,1037.984v51.51a2.008,2.008,0,0,0,2.245,1.994l43.861-5.215a2.427,2.427,0,0,0,2.065-3.019c-1.222-4.719-3.562-14.65-3.573-21.568a.494.494,0,0,0-.258-.435l-43.607-23.7a.5.5,0,0,0-.733.436",
				transform: "translate(-1076.971 -1037.487)",
				fill: "#b8b8d0"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-19",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39643",
				"data-name": "Path 39643",
				d: "M1133.1,944.439l-52.983,5.431a.789.789,0,0,0-.693.939c7.091,35.352,18.12,46.024,20.1,47.694a.787.787,0,0,0,.674.168l47.406-10.16a.786.786,0,0,0,.5-1.191c-9.4-14.768-13.44-37.836-14.143-42.224a.787.787,0,0,0-.777-.662.816.816,0,0,0-.082,0",
				transform: "translate(-1079.407 -944.435)",
				fill: "#2bd5c4"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-20",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39644",
				"data-name": "Path 39644",
				d: "M2075.158,1627.111a2.285,2.285,0,0,1,.486,2.928l.575,3.46,2.089-.347-1.585-2.231.93-1.674a3.145,3.145,0,0,0-2.6-2.753c-.323,0-.391.21.1.617",
				transform: "translate(-2074.8 -1626.494)",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-21",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39646",
				"data-name": "Path 39646",
				d: "M1389.1,1789.777a2.609,2.609,0,0,0,1.641,1.372c.889.241.932,2.849.932,2.849h1.521l-1.422-3.5a1.969,1.969,0,0,0-.462-1.836c-.765-.658-.408-.466-.414.21s-1.013.046-1.859-.564a.643.643,0,0,0-.332-.152c-.365,0-.006,1.045.4,1.625",
				transform: "translate(-1388.555 -1788.152)",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-23",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39648",
				"data-name": "Path 39648",
				d: "M1928.307,2889.635s.482.529.716.377l.321-2.332-1.147-.16Z",
				transform: "translate(-1928.197 -2887.521)",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-24",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39649",
				"data-name": "Path 39649",
				d: "M1858.248,2855.059l1.787.941.544-.887-1.706-1.275Z",
				transform: "translate(-1858.248 -2853.839)",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-26",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39651",
				"data-name": "Path 39651",
				d: "M1905.557,2388.31a108.637,108.637,0,0,0,1.025,16.911,2.142,2.142,0,0,0,1.8.423c.866-2.294,1.494-4.254,1.931-5.717,1.153-3.863,1.73-5.845,1.743-8.3.012-2.305-.43-2.229-.386-4.77a27.7,27.7,0,0,1,.984-6.338,56.2,56.2,0,0,1,1.938-6.482l-7.527-1.977a108.645,108.645,0,0,0-1.511,16.251",
				transform: "translate(-1905.541 -2372.058)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-28",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16942",
				"data-name": "Rectangle 16942",
				width: 9.054,
				height: 33.632,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-29",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39652",
				"data-name": "Path 39652",
				d: "M1907.211,2403.661c-.124-1.739,1.042-2.246,1.408-4.33.448-2.546-1.082-2.983-.909-5.923.139-2.363,1.142-2.334,1.536-5.153.419-3-.6-3.861.057-5.565.364-.947,1.248-2.149,3.59-3.134a56.207,56.207,0,0,1,1.7-5.52l-7.527-1.977a108.613,108.613,0,0,0-.486,33.162,2.146,2.146,0,0,0,.794.4,2.09,2.09,0,0,0,.548.068,4.316,4.316,0,0,1-.714-2.029",
				transform: "translate(-1905.541 -2372.058)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-2",
			x1: -4.68,
			y1: 1.1,
			x2: -4.677,
			y2: 1.1,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#311944"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#893976"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-30",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39653",
				"data-name": "Path 39653",
				d: "M1731.383,2340.937c-1.937,4.333-3.28,5.551-4.239,8.455a17.492,17.492,0,0,0-.7,7.451c.8,7.644,6.759,12.512,8.352,13.736l1.063-1.816a18.372,18.372,0,0,1-1.072-3.25c-.557-2.433-.328-3.736-.553-6.057-.407-4.186-1.535-3.871-1.313-5.9.353-3.219,3.174-3.89,6.853-9.339a33.234,33.234,0,0,0,2.192-3.752l-8.8-4.164a46.316,46.316,0,0,1-1.783,4.639",
				transform: "translate(-1726.32 -2336.298)",
				fill: "#001536"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-31",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39654",
				"data-name": "Path 39654",
				d: "M1466.574,1700.1c.21.449,3.092,6.864-.345,11.915a11.991,11.991,0,0,1-6.044,4.317c-1.493.531-2.485.587-7.377.636-4.372.044-7.009.027-8.682.01-2.715-.027-2.9-.055-3.837.178-2.786.688-4.692,1.686-6.838.7a8.068,8.068,0,0,1-3.1-3.091,17.732,17.732,0,0,1-2.715-6.047l-1.789.511c-1.709,8.411,1.643,16.173,7.518,18.976a14.018,14.018,0,0,0,9.815.5c1.5,2.8,2.779,4.956,3.662,6.393,2.088,3.4,3.129,4.719,2.777,6.47a3.886,3.886,0,0,0-.128,2.428,2.8,2.8,0,0,0,1.612,1.38c2.531,1.094,11.9,3.707,13.533.409a5.7,5.7,0,0,0,.256-1.534,28.145,28.145,0,0,0,.069-5.276c-.2-2.165-.306-5.782-.3-11.518a21.141,21.141,0,0,0,5.725-7.157,21.881,21.881,0,0,0,2.14-9.35,22.551,22.551,0,0,0-2.839-11.022l-3.108.173",
				transform: "translate(-1425.401 -1699.927)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-3",
			x1: .5,
			x2: .5,
			y2: 1,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#7284fa"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#bb65c7"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-32",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39655",
				"data-name": "Path 39655",
				d: "M4.106,3.3l.1.9A2.223,2.223,0,0,1,1.83,6.669L.208,6.547A.191.191,0,0,0,.1,6.9,16.707,16.707,0,0,0,7.865,9.026a11.854,11.854,0,0,0,4.769-.69.441.441,0,0,0-.125-.838c-.828-.12-1.88-.28-2.3-.372-.737-.162-3-3.472-3.68-4.335S6.332,0,6.332,0Z",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-33",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39656",
				"data-name": "Path 39656",
				d: "M1809.243,1887.109l-.048.017-.4.234c-.289.184-.444.33-1.064,1.414-.148.259-1.337,1.869-1,3.191.249.974,2.062,1.194,2.284,1.317-.016.115,2.483.11,2.434-.216q-.028-.187-.059-.372c.242-3.214-.3-5.5-.857-5.635a2.5,2.5,0,0,0-.432-.025,3.748,3.748,0,0,0-.861.074",
				transform: "translate(-1806.673 -1887.035)",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-34",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39657",
				"data-name": "Path 39657",
				d: "M1814.193,1881.014c-.552.062-1.319.152-1.381.463-.079.393.961,1.176,1.406,1.513a1.651,1.651,0,0,1,.352.4.508.508,0,0,1,.054.12c.2.633-.812,1.35-.625,1.635.07.107.286.09.49.073s.37-.032.407.054c.073.168-.5.5-.418.7.062.151.412.022.626.257.106.116.072.207.18.559a3.182,3.182,0,0,0,.216.54c.332.593,1.3.829,1.5.6.053-.064.01-.12.068-.338a1.742,1.742,0,0,1,.2-.433,4.529,4.529,0,0,1,1.2-.9,3.229,3.229,0,0,0,1.264-1.376l.024-.058c.013-.032.025-.064.035-.1.2-.638-.615-1.746-.615-1.746a6.869,6.869,0,0,0-2.127-1.834,9.624,9.624,0,0,0-1.868-.186,9.053,9.053,0,0,0-.986.054",
				transform: "translate(-1812.808 -1880.96)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-35",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39658",
				"data-name": "Path 39658",
				d: "M1803.838,1916.222a10.638,10.638,0,0,0-.612,1.75.644.644,0,0,0,.382.73,7.945,7.945,0,0,0,1.025.174c.262,0,1.485-2.692,1.485-2.692l-.5-.147c-1.013,1.105-1.781.185-1.781.185",
				transform: "translate(-1803.212 -1916.037)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-36",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39659",
				"data-name": "Path 39659",
				d: "M1825.381,1917.954c-.339.445-.585,1.116-.178,1.211s.838-.347.845-.781a.522.522,0,0,0-.423-.565.307.307,0,0,0-.244.135",
				transform: "translate(-1824.991 -1917.819)",
				fill: "#efbfa5"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-38",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16952",
				"data-name": "Rectangle 16952",
				width: 38.317,
				height: 26.749,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-39",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39660",
				"data-name": "Path 39660",
				d: "M1481.377,2053.057c-3.174,1.118-6.872-.517-7.8-2.748-.683-1.649.776-3.222-.256-4.92-.993-1.635-2.788-.9-4.026-2.556-1.349-1.8.239-3.4-.958-5.815a6.3,6.3,0,0,0-5.176-3.451c-2.519,0-3.459,2.323-5.623,1.853-1.13-.245-1.1-.928-2.684-2.045-2.741-1.938-4.58-1.126-6.838-2.492a6.88,6.88,0,0,1-2.093-2.006,13.745,13.745,0,0,0,6.671,7.562,14.018,14.018,0,0,0,9.815.5c1.5,2.8,2.779,4.957,3.662,6.393,2.088,3.4,3.129,4.719,2.777,6.47a3.884,3.884,0,0,0-.128,2.428,2.8,2.8,0,0,0,1.612,1.38c2.53,1.094,11.9,3.707,13.533.409a5.708,5.708,0,0,0,.256-1.534c.056-.536.094-1.05.119-1.531a6.255,6.255,0,0,1-2.867,2.106",
				transform: "translate(-1445.927 -2028.877)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-4",
			x1: -1.98,
			y1: 1.688,
			x2: -1.979,
			y2: 1.688,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#ff9085"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fb6fbb"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-40",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16954",
				"data-name": "Rectangle 16954",
				width: 56.692,
				height: 32.372,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-41",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39661",
				"data-name": "Path 39661",
				d: "M1232.656,1222.682c-5.982-1.5-7.522-7.732-13-7.686-5.416.046-6.586,6.165-11.415,5.877-5.494-.327-6.563-8.4-13.676-10.285a12.651,12.651,0,0,0-6.885.251,94.609,94.609,0,0,0,13.187,31.753l43.505-8.947a63.65,63.65,0,0,1-5.413-11.266,11.562,11.562,0,0,1-6.3.3",
				transform: "translate(-1187.681 -1210.221)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-5",
			x1: -1.2,
			y1: 2.844,
			x2: -1.199,
			y2: 2.844,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#fff"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#ebeff2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ebeff2"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-42",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16955",
				"data-name": "Rectangle 16955",
				width: 46.75,
				height: 6.117,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-43",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16956",
				"data-name": "Rectangle 16956",
				width: 30.58,
				height: 4.931,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "taskOverviewWidget-empty-state-clip-path-44",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_39641-2",
				"data-name": "Path 39641",
				d: "M448.116,994.763l29.886-.2c-2-7.191-4.513-14.748-3.993-22.9l-30.326-.952c.063,11.269.632,21.377,4.433,24.054",
				transform: "translate(-443.683 -970.709)",
				fill: "#bed3ea"
			})
		})
	] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14590",
		"data-name": "Mask Group 14590",
		transform: "translate(-1385 -779)",
		clipPath: "url(#taskOverviewWidget-empty-state-clip-path)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_14416",
			"data-name": "Group 14416",
			transform: "translate(1495.622 738.383)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_14580",
				"data-name": "Group 14580",
				transform: "translate(-111 46)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14269",
						"data-name": "Group 14269",
						transform: "translate(166.268 -29.449)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_14268",
							"data-name": "Group 14268",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-2)",
							children: [
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14255",
									"data-name": "Group 14255",
									transform: "translate(9.821 -2.787)",
									opacity: .7,
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14254",
										"data-name": "Group 14254",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14253",
											"data-name": "Group 14253",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-3)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39597",
												"data-name": "Path 39597",
												d: "M1381.675,203.83a.124.124,0,0,1-.036-.242,43.8,43.8,0,0,0,16.677-9.271c4.531-4.038,9.217-8.214,10.458-14.508.938-4.758-.653-7.834-2.668-11.728a38.991,38.991,0,0,1-5.022-16.322c-.352-4.457-.789-10,2.026-15.862a19.16,19.16,0,0,1,5.213-6.589c1.751-1.557,3.134-2.786,3.572-5.461.715-4.366-.924-7.7-2.821-11.551a44.778,44.778,0,0,1-3.241-7.882c-2.41-8.545-.071-18.664,6.953-30.074a.123.123,0,1,1,.21.129c-6.987,11.349-9.317,21.4-6.926,29.877a44.576,44.576,0,0,0,3.225,7.84c1.916,3.894,3.571,7.256,2.843,11.7-.452,2.761-1.935,4.079-3.652,5.606a18.953,18.953,0,0,0-5.154,6.511c-2.786,5.8-2.351,11.308-2,15.736a38.771,38.771,0,0,0,4.995,16.228c2.037,3.937,3.646,7.047,2.691,11.89-1.257,6.375-5.974,10.579-10.536,14.644a44.049,44.049,0,0,1-16.77,9.323.122.122,0,0,1-.036.005",
												transform: "translate(-1381.551 -74.282)",
												fill: "#fff"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14258",
									"data-name": "Group 14258",
									transform: "translate(19.14 26.789)",
									opacity: .7,
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14257",
										"data-name": "Group 14257",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14256",
											"data-name": "Group 14256",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-4)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39598",
												"data-name": "Path 39598",
												d: "M1540.736,578.911a.123.123,0,0,1-.1-.054c-7.383-10.735-9.906-19.648-10.723-25.235a27.5,27.5,0,0,1,0-9.673.124.124,0,0,1,.24.061,27.282,27.282,0,0,0,.008,9.594c.815,5.557,3.329,14.426,10.68,25.114a.124.124,0,0,1-.1.193",
												transform: "translate(-1529.514 -543.856)",
												fill: "#fff"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14261",
									"data-name": "Group 14261",
									transform: "translate(30.333 42.697)",
									opacity: .7,
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14260",
										"data-name": "Group 14260",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14259",
											"data-name": "Group 14259",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-5)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39599",
												"data-name": "Path 39599",
												d: "M1707.34,834.814a.124.124,0,0,1-.053-.235,44.872,44.872,0,0,0,15.234-11.447,36.586,36.586,0,0,0,6.869-12.444,34.958,34.958,0,0,0,1.612-14.1.124.124,0,0,1,.245-.035,35.213,35.213,0,0,1-1.618,14.2,36.835,36.835,0,0,1-6.914,12.532,45.114,45.114,0,0,1-15.322,11.516.122.122,0,0,1-.053.012",
												transform: "translate(-1707.217 -796.444)",
												fill: "#fff"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14264",
									"data-name": "Group 14264",
									transform: "translate(9.004 77.637)",
									opacity: .7,
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14263",
										"data-name": "Group 14263",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14262",
											"data-name": "Group 14262",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-6)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39600",
												"data-name": "Path 39600",
												d: "M1391.3,1386.662a.123.123,0,0,1-.062-.017c-12.929-7.48-18.385-16.685-20.686-23.09a29.888,29.888,0,0,1-1.912-12.247.124.124,0,0,1,.245.029,29.647,29.647,0,0,0,1.9,12.148c2.288,6.362,7.714,15.507,20.573,22.947a.124.124,0,0,1-.062.23",
												transform: "translate(-1368.58 -1351.2)",
												fill: "#fff"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14267",
									"data-name": "Group 14267",
									transform: "translate(33.978 -7.465)",
									opacity: .7,
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14266",
										"data-name": "Group 14266",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14265",
											"data-name": "Group 14265",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-7)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39601",
												"data-name": "Path 39601",
												d: "M1765.223,33.38a.124.124,0,0,1-.068-.226c9.9-6.579,13.01-15.2,13.879-21.268a31.274,31.274,0,0,0-.49-11.729.124.124,0,0,1,.238-.068,31.532,31.532,0,0,1,.5,11.822c-.875,6.124-4.012,14.816-13.989,21.449a.122.122,0,0,1-.068.021",
												transform: "translate(-1765.1 0)",
												fill: "#fff"
											})
										})
									})
								})
							]
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14278",
						"data-name": "Group 14278",
						transform: "translate(89.075 -36.914)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14277",
							"data-name": "Group 14277",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-8)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_14276",
								"data-name": "Group 14276",
								transform: "translate(-81.595 40.719)",
								opacity: .54,
								style: {
									mixBlendMode: "multiply",
									isolation: "isolate"
								},
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_14275",
									"data-name": "Group 14275",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14274",
										"data-name": "Group 14274",
										clipPath: "url(#taskOverviewWidget-empty-state-clip-path-9)",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14273",
											"data-name": "Group 14273",
											transform: "translate(0 0)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14272",
												"data-name": "Group 14272",
												clipPath: "url(#taskOverviewWidget-empty-state-clip-path-10)",
												children: /* @__PURE__ */ _jsx("path", {
													id: "Path_39666",
													"data-name": "Path 39666",
													d: "M0,0,284.355,33.4l34.783,189.094-284.355-33.4Z",
													transform: "translate(-68.301 11.657) rotate(-16.51)",
													fill: "url(#linear-gradient)"
												})
											})
										})
									})
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14280",
						"data-name": "Group 14280",
						transform: "translate(4.938 3.805)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14279",
							"data-name": "Group 14279",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-11)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_39664",
								"data-name": "Path 39664",
								d: "M0,0,238.449,65.966,303.357,360.4,64.908,294.438Z",
								transform: "matrix(0.539, -0.842, 0.842, 0.539, -115.461, 103.616)",
								fill: "#fafafa"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14282",
						"data-name": "Group 14282",
						transform: "translate(11.09 8.347)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14281",
							"data-name": "Group 14281",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-12)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_39665",
								"data-name": "Path 39665",
								d: "M0,0,249.89,69.232l69.01,265.3L69.01,265.3Z",
								transform: "translate(-118.256 76.4) rotate(-48.35)",
								fill: "#edefff"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14292",
						"data-name": "Group 14292",
						transform: "translate(89.075 17.732)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14417",
							"data-name": "Group 14417",
							transform: "translate(0)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_14285",
								"data-name": "Group 14285",
								opacity: .53,
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_14284",
									"data-name": "Group 14284",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Group_14283",
										"data-name": "Group 14283",
										clipPath: "url(#taskOverviewWidget-empty-state-clip-path-13)",
										children: [/* @__PURE__ */ _jsx("path", {
											id: "Path_39612",
											"data-name": "Path 39612",
											d: "M1038.709,1017.39c-.782,0-1.417-.4-1.417-.883V906.752c0-.488.634-.883,1.417-.883s1.417.4,1.417.883v109.755c0,.488-.634.883-1.417.883",
											transform: "translate(-1037.293 -905.869)",
											fill: "#fff"
										}), /* @__PURE__ */ _jsx("path", {
											id: "Path_39613",
											"data-name": "Path 39613",
											d: "M1748.555,1040.008c-.782,0-1.417-.4-1.417-.883V934.516c0-.487.634-.883,1.417-.883s1.417.4,1.417.883v104.609c0,.488-.635.883-1.417.883",
											transform: "translate(-1675.418 -931.884)",
											fill: "#fff"
										})]
									})
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14294",
						"data-name": "Group 14294",
						transform: "translate(36.704 56.129)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14293",
							"data-name": "Group 14293",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-14)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16902",
								"data-name": "Rectangle 16902",
								width: 45.476,
								height: 40.726,
								transform: "matrix(0.922, -0.387, 0.387, 0.922, -10.16, 4.259)",
								fill: "#b5bdf5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14352",
						"data-name": "Group 14352",
						transform: "translate(38.184 24.223)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14351",
							"data-name": "Group 14351",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-15)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16930",
								"data-name": "Rectangle 16930",
								width: 41.007,
								height: 35.596,
								transform: "matrix(0.92, -0.393, 0.393, 0.92, -8.685, 3.707)",
								fill: "#7284fa"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14359",
						"data-name": "Group 14359",
						transform: "translate(89.075 -36.914)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14358",
							"data-name": "Group 14358",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-8)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_14357",
								"data-name": "Group 14357",
								transform: "translate(67.83 65.344)",
								opacity: .3,
								style: {
									mixBlendMode: "multiply",
									isolation: "isolate"
								},
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_14356",
									"data-name": "Group 14356",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14355",
										"data-name": "Group 14355",
										clipPath: "url(#taskOverviewWidget-empty-state-clip-path-17)",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14354",
											"data-name": "Group 14354",
											transform: "translate(0 0)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14353",
												"data-name": "Group 14353",
												clipPath: "url(#taskOverviewWidget-empty-state-clip-path-18)",
												children: /* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_16931",
													"data-name": "Rectangle 16931",
													width: 55.627,
													height: 60.495,
													transform: "matrix(0.99, -0.139, 0.139, 0.99, -7.487, 0.935)",
													fill: "#b8b8d0"
												})
											})
										})
									})
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14361",
						"data-name": "Group 14361",
						transform: "translate(157.059 22.569)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14360",
							"data-name": "Group 14360",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-19)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16934",
								"data-name": "Rectangle 16934",
								width: 56.227,
								height: 70.577,
								transform: "matrix(0.028, -1, 1, 0.028, -1.617, 54.244)",
								fill: "#2bd5c4"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14363",
						"data-name": "Group 14363",
						transform: "translate(219.751 65.526)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14362",
							"data-name": "Group 14362",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-20)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16935",
								"data-name": "Rectangle 16935",
								width: 5.576,
								height: 7.775,
								transform: "translate(-2.139 0.629) rotate(-17.442)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14365",
						"data-name": "Group 14365",
						transform: "translate(176.53 75.708)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14364",
							"data-name": "Group 14364",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-21)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_39645",
								"data-name": "Path 39645",
								d: "M1342.42,1752.567l4.7,6.1-6.334,4.08-4.7-6.1Z",
								transform: "translate(-1339.391 -1754.808)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14367",
						"data-name": "Group 14367",
						transform: "translate(89.075 -36.914)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14366",
							"data-name": "Group 14366",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-8)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_39647",
								"data-name": "Path 39647",
								d: "M1897.2,2909.774c.139-.506,1.346-.115,2.135.151s1.068.674,1.123,1.006-.214,1.056-.886.569c-.552-.4-2.494-1.278-2.371-1.726",
								transform: "translate(-1777.702 -2726.279)",
								fill: "#26264f"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14369",
						"data-name": "Group 14369",
						transform: "translate(210.518 144.949)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14368",
							"data-name": "Group 14368",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-23)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16937",
								"data-name": "Rectangle 16937",
								width: 1.39,
								height: 2.739,
								transform: "matrix(0.996, -0.094, 0.094, 0.996, -0.247, 0.023)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14371",
						"data-name": "Group 14371",
						transform: "translate(206.112 142.828)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14370",
							"data-name": "Group 14370",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-24)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16938",
								"data-name": "Rectangle 16938",
								width: 2.524,
								height: 2.371,
								transform: "matrix(0.996, -0.094, 0.094, 0.996, -0.202, 0.019)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14373",
						"data-name": "Group 14373",
						transform: "translate(89.075 -36.914)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14372",
							"data-name": "Group 14372",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-8)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_39650",
								"data-name": "Path 39650",
								d: "M1852.573,2869.766s1.19.624,1.925.007a7.175,7.175,0,0,0,1.255-1.626.58.58,0,0,0-.165-.775c-.364-.254-.87-.555-1.134-.479-.441.128-.417,1.671-.677,2.01s-1.145.389-1.2.864",
								transform: "translate(-1735.894 -2686.317)",
								fill: "#26264f"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14375",
						"data-name": "Group 14375",
						transform: "translate(209.091 112.484)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14374",
							"data-name": "Group 14374",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-26)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16940",
								"data-name": "Rectangle 16940",
								width: 9.869,
								height: 33.87,
								transform: "translate(-0.817 0.015) rotate(-1.228)",
								fill: "#002b71"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14382",
						"data-name": "Group 14382",
						transform: "translate(89.075 -36.914)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14381",
							"data-name": "Group 14381",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-8)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_14380",
								"data-name": "Group 14380",
								transform: "translate(120.016 149.398)",
								opacity: .3,
								style: {
									mixBlendMode: "multiply",
									isolation: "isolate"
								},
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_14379",
									"data-name": "Group 14379",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14378",
										"data-name": "Group 14378",
										clipPath: "url(#taskOverviewWidget-empty-state-clip-path-28)",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14377",
											"data-name": "Group 14377",
											transform: "translate(0 0)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14376",
												"data-name": "Group 14376",
												clipPath: "url(#taskOverviewWidget-empty-state-clip-path-29)",
												children: /* @__PURE__ */ _jsx("rect", {
													id: "Rectangle_16941",
													"data-name": "Rectangle 16941",
													width: 24.036,
													height: 33.94,
													transform: "matrix(0.88, -0.475, 0.475, 0.88, -14.16, 7.598)",
													fill: "url(#linear-gradient-2)"
												})
											})
										})
									})
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14384",
						"data-name": "Group 14384",
						transform: "translate(197.803 110.232)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14383",
							"data-name": "Group 14383",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-30)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16944",
								"data-name": "Rectangle 16944",
								width: 37.642,
								height: 31.064,
								transform: "matrix(0.505, -0.863, 0.863, 0.505, -15.23, 25.551)",
								fill: "#002b71"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14386",
						"data-name": "Group 14386",
						transform: "translate(178.851 70.151)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14385",
							"data-name": "Group 14385",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-31)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16945",
								"data-name": "Rectangle 16945",
								width: 59.632,
								height: 60.15,
								transform: "translate(-13.727 3.395) rotate(-15.236)",
								fill: "url(#linear-gradient-3)"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14388",
						"data-name": "Group 14388",
						transform: "translate(199.836 80.907) rotate(-10)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14387",
							"data-name": "Group 14387",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-32)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16946",
								"data-name": "Rectangle 16946",
								width: 15.331,
								height: 12.786,
								transform: "translate(-2.834 0.933) rotate(-18.729)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14390",
						"data-name": "Group 14390",
						transform: "matrix(0.996, -0.087, 0.087, 0.996, 202.437, 77.72)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14389",
							"data-name": "Group 14389",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-33)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16947",
								"data-name": "Rectangle 16947",
								width: 7.007,
								height: 7.709,
								transform: "translate(-2.214 0.656) rotate(-18.729)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14392",
						"data-name": "Group 14392",
						transform: "matrix(0.996, -0.087, 0.087, 0.996, 203.016, 77.036)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14391",
							"data-name": "Group 14391",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-34)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16948",
								"data-name": "Rectangle 16948",
								width: 8.791,
								height: 8.753,
								transform: "translate(-1.781 0.43) rotate(-14.15)"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14394",
						"data-name": "Group 14394",
						transform: "matrix(0.996, -0.087, 0.087, 0.996, 202.341, 80.75)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14393",
							"data-name": "Group 14393",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-35)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16949",
								"data-name": "Rectangle 16949",
								width: 4.069,
								height: 4.086,
								transform: "translate(-1.44 1.715) rotate(-51.009)"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14396",
						"data-name": "Group 14396",
						transform: "matrix(0.996, -0.087, 0.087, 0.996, 204.61, 80.738)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14395",
							"data-name": "Group 14395",
							transform: "translate(0 0)",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-36)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16950",
								"data-name": "Rectangle 16950",
								width: 1.828,
								height: 1.887,
								transform: "matrix(0.85, -0.527, 0.527, 0.85, -0.84, 0.401)",
								fill: "#efbfa5"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14414",
						"data-name": "Group 14414",
						transform: "translate(89.075 -36.914)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_14413",
							"data-name": "Group 14413",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-8)",
							children: [
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14401",
									"data-name": "Group 14401",
									transform: "translate(91.068 127.784)",
									opacity: .3,
									style: {
										mixBlendMode: "multiply",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14400",
										"data-name": "Group 14400",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14399",
											"data-name": "Group 14399",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-38)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14398",
												"data-name": "Group 14398",
												transform: "translate(0)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_14397",
													"data-name": "Group 14397",
													clipPath: "url(#taskOverviewWidget-empty-state-clip-path-39)",
													children: /* @__PURE__ */ _jsx("rect", {
														id: "Rectangle_16951",
														"data-name": "Rectangle 16951",
														width: 44.443,
														height: 37.507,
														transform: "matrix(0.965, -0.263, 0.263, 0.965, -7.21, 1.964)",
														fill: "url(#linear-gradient-4)"
													})
												})
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14406",
									"data-name": "Group 14406",
									transform: "translate(74.803 76.223)",
									opacity: .19,
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14405",
										"data-name": "Group 14405",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14404",
											"data-name": "Group 14404",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-40)",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_14403",
												"data-name": "Group 14403",
												transform: "translate(0 0)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_14402",
													"data-name": "Group 14402",
													clipPath: "url(#taskOverviewWidget-empty-state-clip-path-41)",
													children: /* @__PURE__ */ _jsx("rect", {
														id: "Rectangle_16953",
														"data-name": "Rectangle 16953",
														width: 60.689,
														height: 40.235,
														transform: "matrix(0.99, -0.139, 0.139, 0.99, -4.505, 0.352)",
														fill: "url(#linear-gradient-5)"
													})
												})
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14409",
									"data-name": "Group 14409",
									transform: "translate(72.668 64.122)",
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14408",
										"data-name": "Group 14408",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14407",
											"data-name": "Group 14407",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-42)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39662",
												"data-name": "Path 39662",
												d: "M1154.66,1024.22a.883.883,0,0,1-.084-1.762l44.984-4.351a.883.883,0,0,1,.17,1.758l-44.984,4.351a.852.852,0,0,1-.086,0",
												transform: "translate(-1153.778 -1018.102)",
												fill: "#fff"
											})
										})
									})
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_14412",
									"data-name": "Group 14412",
									transform: "translate(89.628 68.022)",
									style: {
										mixBlendMode: "soft-light",
										isolation: "isolate"
									},
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_14411",
										"data-name": "Group 14411",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_14410",
											"data-name": "Group 14410",
											clipPath: "url(#taskOverviewWidget-empty-state-clip-path-43)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_39663",
												"data-name": "Path 39663",
												d: "M1423.955,1084.941a.883.883,0,0,1-.1-1.761l28.814-3.165a.883.883,0,1,1,.193,1.755l-28.814,3.164a.847.847,0,0,1-.1.006",
												transform: "translate(-1423.073 -1080.01)",
												fill: "#fff"
											})
										})
									})
								})
							]
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_14418",
						"data-name": "Group 14418",
						transform: "translate(111.21 25.641)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_14351-2",
							"data-name": "Group 14351",
							clipPath: "url(#taskOverviewWidget-empty-state-clip-path-44)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16930-2",
								"data-name": "Rectangle 16930",
								width: 41.007,
								height: 35.596,
								transform: "matrix(0.92, -0.393, 0.393, 0.92, -8.685, 3.707)",
								fill: "#bed3ea"
							})
						})
					})
				]
			})
		})
	})]
});
export default SvgTaskOverview;
